"use client"

import { Card, CardMetaProps } from "antd"

const CardMeta = (props: CardMetaProps) => {
  return <Card.Meta {...props} />
}

export default CardMeta